<template>
    <div @scroll="setTasksDropmenuPosition" class="time-tracker h-full">
        <div class="time-tracker-nav">
            <div class="time-btns">
                <Dropmenu :id="`projects-dropmenu`" class="dropmenu-holder projects-dropmenu" :showList="showProjectsDropmenu" dropsize="xl">
                    <template #button>
                        <VButton class="time-header-btn">
                            <i class="icon-projects-btn"></i>
                            <span>Projects</span>
                        </VButton>
                    </template>
                    <template class="projects-dropmenu-wrap" #dropcontent>
                        <div class="projects-dropmenu-header">
                            <div class="projects-dropmenu-title">Projects</div>
                            <label>
                                <span>Select all</span>
                                <input
                                    type="checkbox"
                                    v-model="selectAll"
                                    @change="toggleSelectAll"
                                    :checked="selectedProjects?.length == boards?.length"
                                >
                            </label>
                        </div>
                        <ul class="dropmenu-list">
                            <li class="dropmenu-link" v-for="board in boards" :key="board.id">
                                <a href="#" :class="{'project-selected': isProjectSelected(board.id) }" @click.prevent="toggleProjectSelection(board.id)">
                                    <i v-if="isProjectSelected(board.id)" class="icon-tik"></i>
                                    <span :class="['mg-default', {'mg-left-5': isProjectSelected(board.id) }]">{{ board.title }}</span>
                                </a>
                            </li>
                        </ul>
                    </template>
                </Dropmenu>
                <Dropmenu
                    :id="`listoptions-${Date.now()}`"
                    :right="true"
                    class="dropmenu-holder"
                    :showList="showExportButtons"
                >
                    <template #button>
                        <VButton
                            class="nav-title-options time-header-btn"
                            ref="navTitleOptions"
                            @click.prevent="showExportButtons = !showExportButtons"
                        >
                            <i class="icon-download-small"></i>
                            <span>Export</span>
                        </VButton>
                    </template>
                    <template #dropcontent>
                        <ul class="dropmenu-list">
                            <li>
                                <a 
                                    href="#" @click.prevent="downloadCSV('time')"
                                    class="hide-menu-link"
                                >
                                    <i class="icon-export-dropdown"></i>
                                    <span>Export Time</span>
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#" @click.prevent="downloadCSV('price', 'expensePrice')"
                                    class="hide-menu-link"
                                >
                                    <i class="icon-export-dropdown"></i>
                                    <span>Export Expense Price</span>
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#" @click.prevent="downloadCSV('price', 'billablePrice')"
                                    class="hide-menu-link"
                                >
                                    <i class="icon-export-dropdown"></i>
                                    <span>Export Billable Price</span>
                                </a>
                            </li>
                        </ul>
                    </template>
                </Dropmenu>
                <!-- <VButton class="time-header-btn" @clickHandler="toggleBillExpTable()">
                    <i class="icon-projects-btn"></i>
                    <span>Bill/Exp</span>
                </VButton> -->
            </div>
            <div class="pagination-container">
                <VButton @clickHandler="substractDays()">
                    <i class="icon-backward-step"></i>
                </VButton>
                <a href="#" @click.prevent="todays()">
                    {{
                        new Date(currentDate).toLocaleString("default", {
                            year: "numeric",
                            month: "long",
                        })
                    }}
                </a>
                <VButton @clickHandler="addDays()">
                    <i class="icon-forward-step"></i>
                </VButton>
            </div>
            <div style="width: 15%;"></div>
        </div>
        <div class="table-holder" ref="tableHolder">
            <div class="table-col users-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="user-wrap">
                                <span>User</span>
                                <i
                                    v-if="isSmallScreen"
                                    @click="isUsernameVisible = !isUsernameVisible"
                                    :class="['icon-back', {'reverse' : !isUsernameVisible}]"
                                ></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(listItem, i) in timeTrackerTasks" :key="i">
                            <td>
                                <div :class="['flex-gap-9', {
                                    'center' : isSmallScreen && isUsernameVisible,
                                    'mobile-view' : isSmallScreen && !isUsernameVisible}
                                    ]"
                                >
                                    <UserAvatar
                                        :user="listItem.user"
                                        size="large"
                                    ></UserAvatar>
                                    <span :class="['username', {'mobile-view' : isSmallScreen && isUsernameVisible}]">{{ listItem.user.username }}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="scroll-table smooth-dnd-container vertical lists" ref="scrollTable">
                <table ref="mainTable" class="table">
                    <thead>
                        <tr>
                            <th
                                v-for="(day, i) in daysInMonth(currentDate)"
                                :class="{'weekend-day': isWeekend(day)}"
                                :key="i"
                            >{{day}} <br> {{ getDayName(day) }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in timeTrackerTasks" :key="i">
                            <td v-for="(time, j) in item.times.slice(0, daysInMonth(currentDate))" :key="j" :class="{'weekend-day': isWeekend(Number(j) + 1)}">
                                <span v-if="hoursPerDay(time)" class="dropmenu-holder-opener" @click="openTasksDropmenu($event, time)">
                                    {{hoursPerDay(time, i)}}
                                </span>
                                <span v-else class="zero-time">0</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div :class="['table-col', 'hours-table', {'multiple-column': selectedProjects.length === 1 && currentUserBoardRole === 'owner'}]">
                <table ref="hoursTable" class="table fixed-width-table">
                    <thead class="totals-table" ref="totalsTable">
                        <tr>
                            <th>
                                <div class="totals-table__inner-wrap">
                                    <span v-if="totalExpenseVisible">
                                        {{ getTotalExpenses() }}
                                    </span>
                                    <span class="hiden-price" v-else>***</span>
                                    <button class="show-price" @click="totalExpenseVisible = !totalExpenseVisible">
                                        <i
                                            class="icon-view"
                                            :class="{'icon-unview' : totalExpenseVisible}"
                                        ></i>
                                    </button>
                                    <i class="icon-question-mark">
                                        <Tooltip>
                                            <div class="tooltip__info">The calculated expenses and billables <br>
                                                are
                                                <span class="tooltip__blue-text">only calculated from the projects <br>
                                                    you are the owner of.
                                                </span>
                                            </div>
                                            <div v-if="boardsNotOwnerOf.length == 0">You're owner of all the boards</div>
                                            <div v-else>
                                                <div class="tooltip__list">These are not calculated with:</div>
                                                <p v-for="board in boardsNotOwnerOf" class="tooltip__item">- {{ board }}</p>
                                            </div>
                                        </Tooltip>
                                    </i>
                                </div>
                            </th>
                            <th>
                                <div class="totals-table__inner-wrap">
                                    <span v-if="totalBillableVisible">
                                        {{ getTotalPriceClient() }}
                                    </span>
                                    <span class="hiden-price" v-else>***</span>
                                    <button class="show-price" @click="totalBillableVisible = !totalBillableVisible">
                                        <i
                                            class="icon-view"
                                            :class="{'icon-unview' : totalBillableVisible}"
                                        ></i>
                                    </button>
                                    <i class="icon-question-mark">
                                        <Tooltip>
                                            <div class="tooltip__info">The calculated expenses and billables <br>
                                                are
                                                <span class="tooltip__blue-text">only calculated from the projects <br>
                                                    you are the owner of.
                                                </span>
                                            </div>
                                            <div v-if="boardsNotOwnerOf.length == 0">You're owner of all the boards</div>
                                            <div v-else>
                                                <div class="tooltip__list">These are not calculated with:</div>
                                                <p v-for="board in boardsNotOwnerOf" class="tooltip__item">- {{ board }}</p>
                                            </div>
                                        </Tooltip>
                                    </i>
                                </div>
                            </th>
                            <th>{{ getTotalHours() }}</th>
                        </tr>
                    </thead>
                    <thead class="row-totals-thead">
                        <tr>
                            <th :class="{'bill-exp' : !isBillExpOpen}">Expense</th>
                            <th class="bill-exp">Billable</th>
                            <th class="row-total-hours total-hours-th">Total Hours</th>
                        </tr>
                    </thead>
                    <tbody class="row-totals-tbody">
                        <tr class="mainTableTR" v-for="(item, i) in timeTrackerTasks" :key="i">
                            <td class="row-total-price-agents bill-exp">
                                
                                <button class="show-price" @click="item.isExpenseVisible = !item.isExpenseVisible">
                                    <span v-if="item.isExpenseVisible">
                                        {{ roundVal(Number(item.agent)) }}
                                    </span>
                                    <i :class="{'icon-view' : !item.isExpenseVisible}"></i>
                                </button>
                            </td>
                            <td class="row-total-price-clients bill-exp">
                                <button class="show-price" @click="item.isBillableVisible = !item.isBillableVisible">
                                    <span v-if="item.isBillableVisible">
                                        {{ roundVal(Number(item.client)) }}
                                    </span>
                                    <i :class="{'icon-view' : !item.isBillableVisible}"></i>
                                </button>
                            </td>
                            <td class="row-total-hours">{{ calcTotalHours(item.times) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="loadingTimes" class="loader">
                <LoaderAnimationVue color="#fff" size="30px" margin="10px" />
            </div>
        </div>
        <div
            v-if="showTasksDropmenu"
            ref="tasksDropmenu"
            class="list_pop_up lg tasksDropmenu"
            :style="timeDetailsModal?.length > 4 ? 'height: 100%;' : 'height: auto;'"
        >
            <div class="table-thead">
                <table class="small-time-table ">
                    <thead>
                        <tr>
                            <th class="title-column">Project</th>
                            <th class="title-column">Task</th>
                            <th class="cell-center">Hours</th>
                            <th class="cell-center">Mins</th>
                            <th class="note-column">Note</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="table-tbody">
                <table class="small-time-table ">
                    <tbody>
                        <tr
                            v-for="(detail, t) in timeDetailsModal"
                            :key="t"
                        >
                            <td class="cell-center title-column">
                                <div>
                                    <a href="#" @click.prevent="openEditTask(detail['task'])">{{ detail['task']['project'] }}</a>
                                </div>
                            </td>
                            <td class="title-column">
                                <div>
                                    <a href="#" @click.prevent="openEditTask(detail['task'])">{{detail['task']['title'] || 'No Title'}}</a>
                                </div>
                            </td>
                            <td class="cell-center">{{ convertTimeToHMSystem(detail.minutes, 'h') }}</td>
                            <td class="cell-center">{{ convertTimeToHMSystem(detail.minutes, 'm') }}</td>
                            <td class="note-column">
                                <span v-if="!detail.note" class="zero-time"></span>
                                <VButton size="xs" v-if="detail.note?.length >= 10" @clickHandler="showNote(detail.note)">Note</VButton>
                                <span v-else>{{ detail.note }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <VModal class="edit-task-modal" ref="edit-task" size="xl" @hideModal="closeModalEditTask">
            <EditTask
                :task="task"
                :tags="tags"
                :allEvents="events"
                :board_id_from_task="board_id_from_task"
                @hideModal="hideEditModal"
                @toggleConflictSaving="toggleConflictSaving"
            />
        </VModal>
        <VModal ref="note-modal" class="note-modal">
            <div class="text-holder">{{ noteText }}</div>
            <VButton @clickHandler="hideNoteModal">Ok</VButton>
        </VModal>
    </div>
</template>

<script>
import { api } from "@/mixins/axios";
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import VButton from "@/components/atoms/VButton.vue";
import VCheckboxToggle from "@/components/atoms/VCheckboxToggle.vue";
import VModal from "@/components/atoms/VModal.vue";
import EditTask from "@/components/molecules/EditTask.vue";
import UserAvatar from "@/components/atoms/UserAvatar.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import Tooltip from "@/components/atoms/Tooltip.vue";
import {Container} from "vue-smooth-dnd";

export default {
    name: "TimeTracker",
    components: {
        Dropmenu,
        VCheckboxToggle,
        VButton,
        VModal,
        EditTask,
        UserAvatar,
        LoaderAnimationVue,
        Tooltip,
        Container,
    },
    props: ["board_id", 'currentUser', 'dragScroll'],
    data: () => ({
        timeDetailsModal: null,
        timeTableDataList: [],
        currentDate: new Date(),
        allHours: 0,
        allPriceAgents: 0,
        allPriceClients: 0,
        currentUserBoardRole: null,
        currentMonth: new Date().getMonth(),
        task: {
            id: "",
            title: "",
            body: "",
            tags: [],
            is_template: false,
        },
        tags: [],
        events: [],
        board_id_from_task: null,
        task_board_id: null,
        callBoardsOnce: false,
        headerData: [],
        originalParentHeight: null,
        originalParentWidth: null,
        showProjectsDropmenu: false,
        selectedProjects: [],
        selectAll: false,
        loadingTimes: false,
        showTasksDropmenu: false,
        currentActiveDropmenuButton: null,
        boardsNotOwnerOf: [],
        totalExpenseVisible: false,
        totalBillableVisible: false,
        showExportButtons: false,
        isSmallScreen: false,
        isUsernameVisible: true,
        isBillExpOpen: false,
        noteText: null
    }),
    async mounted() {
        if (this.boards) {
            this.getMembers()
            this.selectedProjects = this.boards.map(board => board.id)
            this.selectAll = true
            this.getBoardTime()
            this.tagsSearch()
        }

        this.board_id_from_task = Number(this.$route.params.board_id)

        window.addEventListener('click', e => {
            if (!this.$refs.tasksDropmenu) return

            console.log(e)
            if (e.target.classList.contains('dropmenu-holder-opener') || this.$refs.tasksDropmenu.contains(e.target) || e.target.closest('.note-modal')) return

            this.showTasksDropmenu = false
        })

        window.addEventListener('keydown', e => {
            if (e.key == 'Escape' && this.showTasksDropmenu) this.showTasksDropmenu = false
        }),
        await this.checkScreenWidth();
    },
    watch: {
        async $route() {
            await this.getTags();
        },
        async boards(newVal) {
            if (newVal !== null) {
                this.getMembers()
                if (!this.callBoardsOnce) {
                    this.selectedProjects = this.boards.map(board => board.id)
                    this.selectAll = true
                    this.getBoardTime()

                    this.callBoardsOnce = false
                }
            }
        },
        selectedProjects(value) {
            if (value.length === 1) {
                const currentBoard = this.boards.filter(board => board.id == value[0])
                this.currentUserBoardRole = currentBoard && currentBoard[0].current_user_role
            }
        },
        '$route'() {
            this.checkScreenWidth();
        }
    },
    methods: {
        async tagsSearch() {
            try {
                let data = {
                    paginate_by: 2000
                };

                const response = await api.post(`/tag_search`, data);

                if(response.status === 200) {
                    this.$store.dispatch('setTags', response.data.data)
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        openTasksDropmenu(event, time) {
            this.timeDetailsModal = time
            this.showTasksDropmenu = true
            this.currentActiveDropmenuButton = event.target

            this.$nextTick(() => this.setTasksDropmenuPosition())
        },
        setTasksDropmenuPosition() {
            const tasksDropmenu = this.$refs.tasksDropmenu
            if (!tasksDropmenu) return

            const buttonRect = this.currentActiveDropmenuButton.getBoundingClientRect()
            tasksDropmenu.style.left = buttonRect.left + 'px';
            tasksDropmenu.style.top = buttonRect.bottom + 'px';
            tasksDropmenu.style.bottom = 'auto'
            tasksDropmenu.style.right = 'auto'
            tasksDropmenu.style.height = tasksDropmenu.querySelector('.table-tbody').offsetHeight >= 130 ? '100%' : 'auto'

            const tasksDropmenuRect = tasksDropmenu.getBoundingClientRect();

            if (tasksDropmenuRect.right > window.innerWidth) {
                const newRightPos = window.innerWidth - buttonRect.right
                tasksDropmenu.style.left = 'auto'
                tasksDropmenu.style.right = newRightPos + 'px'
            }
            if(tasksDropmenuRect.bottom > window.innerHeight) {
                const newBottomPos = window.innerHeight - buttonRect.bottom + buttonRect.height
                tasksDropmenu.style.top = 'auto'
                tasksDropmenu.style.bottom = newBottomPos + 'px'
            }
        },
        closedDropmenu() {
            const dropmenu = this.$refs.tableHolder;
            if (dropmenu) {
                dropmenu.style.height = this.originalParentHeight;
            }
        },
        formattedTask(task) {
            const allUsers = this.boards.flatMap(board => board.members).filter(user => user)
            const usersMap = new Map(allUsers.map(user => [user?.id, user]))
            const tagMap = new Map(this.allTags.map(tag => [tag?.id, tag]))
            
            let tags = null;
            if(typeof task.tags == 'string') {
                tags = task.tags.split('|')
                        .filter(tag => tag.trim() !== '')
                        .map(tag => {
                            let t = tag.split(':')
                            return {
                                tagType: t[0],
                                id: Number(t[1])
                            }
                        })
                        .filter(tag => tag.id)
                        .map(tag => {
                            if(tag.tagType == 'user') {
                                return {
                                    tagType: tag.tagType,
                                    ...usersMap.get(tag.id)
                                }
                            }
                            if(tag.tagType == 'tag') {
                                return {
                                    tagType: tag.tagType,
                                    ...tagMap.get(tag.id)
                                }
                            }
                        })
                } else if(typeof task.tags == 'array' || (typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'string')) {
                    tags = task.tags
                            .map(tag => {
                                let t = tag.split(':')
                                return {
                                    tagType: t[0],
                                    id: Number(t[1])
                                }
                            })
                            .filter(tag => tag.id)
                            .map(tag => {
                                if(tag.tagType == 'user') {
                                    return {
                                        tagType: tag.tagType,
                                        ...usersMap.get(tag.id)
                                    }
                                }
                                if(tag.tagType == 'tag') {
                                    return {
                                        tagType: tag.tagType,
                                        ...tagMap.get(tag.id)
                                    }
                                }
                            })
                } else if(typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'object') {
                    tags = task.tags
                } else {
                    tags = []
                }

            const updatedTask = {
                ...task,
                tags: tags
            }

            return updatedTask
        },
        async openEditTask(task) {
            try {
                const response = await api.post("/task_search", {id: task.id, archived: true});
                if (response.data.msg == 'ok') {
                    const taskData = response.data.data[0]

                    this.task = Object.assign({}, this.formattedTask(taskData))
                    this.$store.dispatch('setEditableTask', this.task);

                    setTimeout(() => document.title = this.task && this.task.title ? `${this.task.title} | Goleko` : 'Goleko', 500)

                    this.getTags()
                    this.$refs['edit-task'].showModal()

                    // Couldn't this be done via vue router?
                    var newURLSegment = `/app/tasks/${this.titleToSlug(taskData.title)}-${taskData.id}`;
                    var currentState = history.state || {};
                    currentState.urlSegment = newURLSegment;
                    history.pushState(currentState, '', newURLSegment);

                    this.searchTag = "";
                    
                    this.task_board_id = taskData.board_id
                }
            } catch (e) {
                console.log(e)
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        async getTags() {
            if (!this.activeBoard) return
            if (this.board_id && this.boards && !this.from_task) {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            } else {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            }
        },
        async closeModalEditTask() {
            console.log('closeModalEditTask')
            console.log(this.board_id_from_task)
            var newURLSegment = `/app/timetable/${this.board_id_from_task}`;
            var currentState = history.state || {};
            currentState.urlSegment = newURLSegment;
            history.pushState(currentState, '', newURLSegment);
        },
        async getEventsTask(task) {
            try {
                const data = {
                    task,
                    board: this.task_board_id,
                    paginate_by: 1000
                };

                const response = await api.post(`/task_event_search`, data);

                if (response.status === 200) {
                    this.events = this.events2.filter(e => {
                        return e.task_id == task.id
                    })
                    this.$forceUpdate()
                }
            } catch (e) {
                console.error(e);
            }
        },
        hideEditModal() {
            this.$refs['edit-task'].hideModal();
        },
        toggleConflictSaving(mode) {
            if (mode == 'show') {
                this.$refs['conflict-saving'].$refs['conflict-saving'].showModal()
            } else {
                this.$refs['conflict-saving'].$refs['conflict-saving'].hideModal()
            }
        },
        titleToSlug(title) {
            let slug = title.toLowerCase();

            slug = slug.replace(/\s+/g, '-');
            slug = slug.replace(/[^a-z0-9\-]/g, '');
            slug = slug.replace(/-+/g, '-');
            slug = slug.replace(/^-+|-+$/g, '');

            return slug;
        },
        preventOverlap() {
            this.$nextTick(() => {
                let maxHeight = 0;
                this.$refs.totalsTable.querySelectorAll('tr th').forEach(th => {
                    if (th.offsetHeight > maxHeight) maxHeight = th.offsetHeight;
                })
                this.$refs.hoursTable.style.transform = `translateY(-${maxHeight}px)`
            })
        },
        async getBoardTime(month, year) {
            try {
                const payload = {
                    month: month ? month : this.currentDate.getMonth() + 1,
                    year: year ? year : this.currentDate.getFullYear(),
                    projects: this.selectedProjects
                };

                this.loadingTimes = true
                const response = await api.post('/time_get', payload);

                if (response.status !== 200) { return; }

                this.loadingTimes = false
                this.boardsNotOwnerOf = this.boards.filter(board => response.data.not_own_projects.includes(board.id)).map(project => project.title)
                this.timeTableDataList = [];

                const { members, prices, times } = response.data || {};

                Object.keys(prices).forEach(id => {
                    const userTimes = times[id];
                    const userPrices = prices[id];
                    
                    const user = members.find(member => id == member.id);

                    this.timeTableDataList.push({
                        user,
                        times: userTimes,
                        agent: userPrices.expense,
                        client: userPrices.billable,
                        isExpenseVisible: false,
                        isBillableVisible: false,
                    });
                });

                this.timeTableDataList.forEach(item => {
                    if (this.daysInMonth(this.currentDate) >= 31) { return; }

                    const timesKeys = Object.keys(item.times);

                    timesKeys.slice(this.daysInMonth(this.currentDate)).forEach(key => {
                        delete item.times[key];
                    });
                })

                this.$store.dispatch('setTimeTrackerTasks', this.timeTableDataList)

                this.preventOverlap()

                this.$nextTick(() => this.dragScroll())
            } catch (e) {
                console.error(e);
            }
        },
        roundVal(number) {
            return (Math.round(number * 100) / 10000).toFixed(2);
        },
        getTotalExpenses() {
            return this.roundVal(this.timeTrackerTasks?.reduce((a, b) => a + Number(b.agent), 0))
        },
        getTotalPriceClient() {
            return this.roundVal(this.timeTrackerTasks?.reduce((a, b) => a + Number(b.client), 0))
        },
        getTotalHours() {
            let getTotalHours = 0
            this.timeTrackerTasks?.forEach(agentObj => {
                const totalMinutes = this.calculateTotalMinutes(agentObj.times);
                getTotalHours += totalMinutes
            });
            return this.convertTimeToHMSystem(getTotalHours)
        },
        calculateTotalMinutes(agentData) {
            let totalMinutes = 0;
            agentData.forEach(timeSlots => {
                timeSlots.forEach(timeSlot => {
                    if (timeSlot.minutes) {
                        totalMinutes += timeSlot.minutes;
                    }
                });
            });
            return totalMinutes;
        },
        minutesToHours(min) {
            var decimalHours = min / 60;
            return `${decimalHours.toFixed(2)}h`
        },
        convertTimeToHMSystem(min, unit) {
            const decimalHours = min / 60;
            const hours = Math.floor(decimalHours);
            const minutes = min % 60;

            if (unit === 'm') {
                return `${minutes}m`;
            } else if (unit === 'h') {
                return `${hours}h`;
            } else {
                return `${hours}h ${minutes}min`;
            }
        },
        hoursPerDay(time) {
            if (typeof time === 'object') {
                var allMinutes = time.map(t => t.minutes).reduce((partialSum, a) => partialSum + a, 0)
                return allMinutes != 0 ? this.minutesToHours(allMinutes) : null
            }
        },
        calcTotalHours(time) {
            let totalHours = 0
            for(let a in time) {
                let b = time[a].map(t => t.minutes).reduce((partialSum, a) => partialSum + a, 0)
                totalHours += b
            }
            return this.convertTimeToHMSystem(totalHours)
        },

        getDayName(day) {
            const currentYear = this.currentDate.getFullYear();
            const currentMonth = this.currentDate.getMonth();
            const currentDay = day;
            const dayIndex = new Date(currentYear, currentMonth, currentDay).getDay();
            const weekdays = ["S", "M", "T", "W", "T", "F", "S"];
            return weekdays[dayIndex];
        },

        substractDays() {
            this.currentDate.setDate(1);
            this.currentDate.setMonth(this.currentDate.getMonth() - 1);

            this.fieldsWithEmail = [];
            this.items = [];
            const currentYear = new Date(this.currentDate).toLocaleString("default", {year: "numeric"})
            this.getBoardTime(this.currentDate.getMonth() + 1, Number(currentYear));
        },
        todays() {
            this.currentDate = new Date();
            this.getBoardTime()
        },
        addDays() {
            this.currentDate.setDate(1);
            this.currentDate.setMonth(this.currentDate.getMonth() + 1);
            this.fieldsWithEmail = [];
            this.items = [];
            const currentYear = new Date(this.currentDate).toLocaleString("default", {year: "numeric"})
            this.getBoardTime(this.currentDate.getMonth() + 1, Number(currentYear));
        },
        getAllPriceFunc(item) {
            let totalMinutes = 0;
  
            for (const key in item?.times) {
                if (Array.isArray(item?.times[key])) {
                    for (const i of item?.times[key]) {
                        if (i.hasOwnProperty('minutes') && typeof i.minutes === 'number') {
                        totalMinutes += i.minutes;
                        }
                    }
                }
            }

            let a = totalMinutes * Number(item?.client)

            return (a / 60).toFixed(2)
        },
        daysInMonth(date) {
            let month = date.getMonth()+1
            let year = date.getFullYear()
            return new Date(year, month, 0).getDate();
        },
        isWeekend(day) {
            const currentYear = this.currentDate.getFullYear();
            const currentMonth = this.currentDate.getMonth();
            const dayIndex = new Date(currentYear, currentMonth, day).getDay();
            return dayIndex === 0 || dayIndex === 6;
        },
        getMembers() {
            if(this.board_id && this.boards) {
                const currentBoard = this.boards.filter(board => board.id === this.board_id)
                this.currentMembers = currentBoard[0] && currentBoard[0].members
            }
        },
        async downloadCSV(type, priceType) {
            try {
                const data = {
                    month: this.currentDate.getMonth() + 1,
                    year: this.currentDate.getFullYear(),
                    projects: this.selectedProjects
                };

                if (priceType == 'expensePrice') data.client = true

                const response = await api.post(`/time_export_${type}`, data);

                if (response.status === 200) {
                    const blob = new Blob([response.data.content], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', type == 'time' ? 'time_table.csv' : 'price_table.csv');
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            } catch (e) {
                console.error(e);
            }
        },
        toggleProjectSelection(projectId) {
            if (this.selectedProjects.length === 1 && this.selectedProjects[0] === projectId) return

            const index = this.selectedProjects.indexOf(projectId);
            if (index === -1) {
                this.selectedProjects.push(projectId);
            } else {
                this.selectedProjects.splice(index, 1);
            }

            this.getBoardTime()
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedProjects = this.boards.map(board => board.id);
            } else {
                this.selectedProjects = []
            }

            this.getBoardTime()
        },
        isProjectSelected(projectId) {
            return this.selectedProjects.includes(projectId);
        },
        showUploadState(files, taskID) {
            this.$emit('showUploadState', files, taskID)
        },
        async checkScreenWidth() {
            this.isSmallScreen = window.innerWidth <= 425;
        },
        toggleBillExpTable() {
            this.isBillExpOpen = !this.isBillExpOpen
        },
        showNote(note) {
            this.noteText = note
            this.$refs['note-modal'].showModal()
        },
        hideNoteModal() {
            this.$refs['note-modal'].hideModal()
            this.noteText = null
        }
    },
    computed: {
        activeMonth() {
            return new Date(this.currentDate).toLocaleString("default", {
                year: "numeric",
                month: "long",
            })
        },
        boards() {
            return this.$store.getters.boards
        },
        events2() {
            return this.$store.getters.events2
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        editableTask() {
            return this.$store.getters.editableTask
        },
        allTags() {
            return this.$store.getters.tags
        },
        timeTrackerTasks() {
            return this.$store.getters.timeTrackerTasks
        }
    },
    destroyed() {
        this.$store.dispatch('setTimeTrackerTasks', [])
    }
};
</script>

<style scoped lang="scss">
.time-tracker {
    padding: 20px 0;
    height: 100%;
    overflow-y: auto;
    .time-tracker-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
        margin-bottom: 15px;
 
        .time-btns {
            display: flex;
            gap: 4px;
            .time-header-btn.btn {
                font-weight: 500;
                padding: 6px 10px;
                min-height: 26px;
                i {
                    margin-right: 8px;
                    pointer-events: all;
                    font-size: 12px;

                    &.icon-download-small {
                        color: $green;
                    }
                }
                .icon-download-small {
                    font-size: 17px;
                }
            }
        }

    }

    .table .dropmenu-holder-opener {
        cursor: pointer;
        user-select: none;
    }

    .table {
        margin: 0;
        border: none;

        .user-wrap {
            display:flex;
            align-items: center;
        }

        .icon-back {
            display: inline-block;
            transform: rotate(180deg);
            margin-top: 6px;
            margin-left: 14px;
            transition: 0.2s ease-in;

            &.reverse {
                transform: rotate(0);
                margin-top: -2px;
            }
        }
        .icon-back:before {
            color: #ffffff;
            font-size: 10px;
        }

        .flex-gap-9 {

            &.mobile-view {
                width: 118px;
            }
            &.center {
                justify-content: center;
            }
        }

        .username {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.mobile-view {
                display: none;
            }
        }

        th,
        td {
            padding: 7px;
        }

        thead {
            th {
                height: 66px;
            }
        }

        tbody {
            td {
                height: 50px;
            }
        }
    }

    .table-holder {
        display: flex;
        height: auto;
        //min-height: calc(100% - 104px);
        width: fit-content;
        max-width: 97%;
        margin: 0 auto;
        border-radius: 20px;
        position: relative;

        .scroll-table {
            overflow-x: auto;
            overflow-y: hidden;
            min-width: 200px;
            background-color: var(--primary-bg);
            display: flex;
            user-select: none;
            padding-bottom: 30px;

            tbody {
                td {
                    height: 48px;

                }
            }

            td, th {
                min-width: 40px;
                border-right: 1px solid var(--outline);
                text-align: center;

                &:last-of-type {
                    border-right: none;
                }

                &:has(+ .weekend-day) {
                    border-right-color: #42505c;
                }

                &.weekend-day {
                    color: $blue-5;
                    border-right: 1px solid var(--outline);
                    background: var(--secondary-bg);
                }
            }
        }

        .table-col {
            //min-height: calc(100% - 104px);

            &.users-table {
                border-radius: 20px 0 0 20px;
                background-color: var(--primary-bg);
                .table {
                    border-right: 2px solid #29343c;
                }

                th, td {
                    padding: 7px 20px;
                }
            }
            &.hours-table {
                border-radius: 0 20px 20px 0;
                position: relative;
                background-color: var(--primary-bg);

                .table {
                    transform: translateY(-40px);
                    border-radius: 20px;

                    .totals-table {
                        th {
                            height: 40px;
                            color: #D8D8D8;
                            font-weight: 400;
                            font-size: 14px;
                            &:nth-of-type(2) {
                                border-left: 1px solid #00000026;
                            }
                        }
                        &__inner-wrap {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            gap: 5px;
                            i {
                                font-size: 11px;
                            }
                        }
                    }

                    .row-totals-thead,
                    .row-totals-tbody {
                        background: var(--primary-bg);
                        border-left: 1px solid #29343c;
                        th,
                        td {
                            &:nth-of-type(2) {
                                border-left: 1px solid #00000026;
                            }
                        }
                    }
                    .show-price {
                        border: none;
                        cursor: pointer;
                    }
                    .hiden-price {
                        margin-top: 3px;
                    }
                }

                .row-total-hours {
                    border-left: 2px solid #29343c;
                }

                .total-hours-th {
                    border-top-right-radius: 20px;
                }

                &.multiple-column {
                    min-width: auto;
                }
            }
        }

        & > .table {
            width: auto;
        }

        .fixed-width-table {
            th,
            td {
                min-width: 80px;
                white-space: nowrap;
                text-align: center;
            }
        }

        .loader {
            position: absolute;
            width: 100%;
            height: 100%;
            padding-top: 200px;
            background: rgba(0,0,0,.4);
            border-radius: 20px;
            display: flex;
            justify-content: center;
        }
    }

    .tasksDropmenu {
        display: block;
        overflow: hidden;

        .small-time-table {
            width: 365px;
            backdrop-filter: blur(6px);
            text-align: left;
            margin-bottom: 10px;
            background: var(--primary-bg);
            table-layout: fixed;

            tr {
                cursor: pointer;
            }

            .cell-center {
                text-align: center;
                padding-left: 5px;
                padding-right: 5px;
            }

            .title-column {
                width: 90px;

                a {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    display: block;
                }
            }

            .note-column {
                width: 70px;
            }

            th,
            td {
                height: auto;
                border: none;
                text-align: left;

                &:first-child {
                    word-break: break-all;
                }
            }

            thead {
                th {
                    font-weight: 500;
                    font-size: 14px;
                    padding-top: 4px;
                    border-bottom: 0.5px solid var(--outline);
                    &:first-of-type {
                        padding-left: 15px;
                    }
                    &:last-of-type {
                        padding-right: 15px;
                    }
                }
            }

            tbody {
                tr:hover td::before {
					background: var(--accent);
				}

                td {
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        width: 100%;
                        transform: translateY(-50%);
                        height: 90%;
                        z-index: -1;
                    }
                }
                
                td:first-of-type {
                    padding-left: 15px;
                    &::before {
                        border-radius: 6px 0 0 6px;
                        width: calc(100% - 6px);
                        right: 0;
                        left: 6px;
                    }
                }
                td:last-of-type {
                    padding: 15px 15px 15px 0;
                    &::before {
                        border-radius: 0 6px 6px 0;
                        left: 0;
                        width: calc(100% - 6px);
                    }
                }
            }
        }

        .table-thead {
            table {
                margin-bottom: 0;
            }
        }

        .table-tbody {
            overflow-x: hidden;
            height: calc(100% - 28px);
            overflow-y: auto;
        }
        .table {
            margin: 0;
            min-height: 0;
            background-color: #33434f;
            color: #fff;
            width: 100%;

            th,
            td {
                height: 40px;
                text-align: left;
            }
        }
    }

    .dropmenu-holder {
        position: relative;

        &.projects-dropmenu {
            margin-left: 10px;
            .projects-dropmenu-wrap {
                margin-top: 10px;
                width: 275px;
                max-height: 426px;
            }
            .projects-dropmenu-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 10px 5px;

                label {
                    display: flex;
                    align-items: center;
                }
                span {
                    display: block;
                    font-weight: 500;
                    font-size: 12px;
                }
            }

            .projects-dropmenu-title {
                font-size: 18px;
                font-weight: 500;
            }

            .projects-info {
                border-radius: 3.454px;
                background: $field-flow;
                margin: 6px 7px;
                padding: 6px;
                color: #DADADA;
                font-size: 12px;
                font-weight: 400;

                p {
                    margin: 0;
                }

                ul {
                    margin: 3px 0;
                    padding-left: 22px;
                }

                &__warning {
                    color: $orange;
                }
            }
            .project-selected {
                background-color: var(--accent);
                color: #fff;
            }

            .mg-default {
                margin-left: 15px;
            } 

            .mg-left-5 {
                margin-left: 5px;
            }

            .dropmenu-list {
                padding: 0 7px 7px;
            }

            .dropmenu-link {
                margin: 2px 0;
                font-weight: 500;
            }
        }
    }

    .zero-time {
        font-size: 0;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        &:before {
            content: '';
            width: 20px;
            height: 3px;
            background-color: rgba(255, 255, 255, .1);
            display: block;
            border-radius: 5px;
        }
    }
}

.pagination-container {
    display: flex;
    align-items: center;
    gap: 15px;
    a {
        color: #fff;
    }
    a.btn {
        min-height: 31px;
        border: none;
    }
    i {
        font-size: 7px;
    }
}

.note-modal {
    position: absolute;
    z-index: 1000;
    text-align: center;

    .text-holder {
        background: var(--secondary-bg);
        color: var(--primary-text);
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 10px;
    }

    p {
        margin: 0;
    }
}
</style>
